import React from 'react';
import cn from 'classnames';

import styles from './lines-count.module.scss';

interface ILinesCountProps {
  children: string;
  className?: string;
}

export default function LinesCount({ children, className }: ILinesCountProps) {
  return (
    <div className={cn(styles['lines-count'], className)}>
      {children}
    </div>
  );
}
